import * as React       from "react";

import "./find-remove-modal.scss";

import {cs}                           from "@Common/react/chain-services";
import {consumeContext}               from "@Common/react/context";
import {Invoke}                       from "@Common/react/invoke";
import {Load2}                        from "@Common/react/load2";
import {UseState}                     from "@Common/react/use-state";
import {InformationBadge}             from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {addURLParameterToWindow}      from "@Common/utils/add-url-parameter";
import {removeURLParameterFromWindow} from "@Common/utils/remove-url-parameter";

import {ModalLayout}                  from "@Xpresso/routes/common/modal-layout/modal-layout";

import {DnmList} from "./dnm-table/dnm-list";

export const FindRemoveModal = ({findRemoveContent, officeId}) => cs(
    consumeContext("apis"),
    ["searchState", ({}, next) => UseState({next, initValue: ""})],
    ["list", ({apis}, next) => Load2({
        fetch: () => apis.next.mailing.dnm.getDoNotMailList(officeId),
        next,
    })],
    ["dnmList", ({list}, next) => list.value ? UseState({next, initValue: list.value}) : next()],
    ({}, next) => Invoke({action: () => addURLParameterToWindow({parameter: "action", value: "find"}), next}),
    ({}, next) => ModalLayout({
        content: next(),
        buttons: [
            {
                label: "Back",
                primary: true,
                onClick: () => {
                    removeURLParameterFromWindow({parameter: "action"})
                    findRemoveContent.onChange(false)
                },
            },
        ]
    }),
    ({dnmList, searchState}) => cs(
        () => (
        <div className="dnm-mgmt-modal-d3rk">
            <span className="title" xd-qa-type="label" xd-qa-name="Search for specific addresses">Search for specific addresses</span>
            <div className="container-address">
                <div className="find-address">
                    <input 
                        onChange={(e) => {
                            searchState.onChange(e.target.value);
                        }}
                        value={searchState.value}
                        className="search-address"
                        type="text"
                        xd-qa-type="textbox"
                        xd-qa-name="Address..."
                        placeholder="Address..."
                    />
                </div>
                {InformationBadge({
                    getTooltip: () => "Enter any part of an address to filter results",
                    xdQaName: "Address Search"
                })}
            </div>

            <div className="table-container">
                {!dnmList?.value ? "Loading..." : DnmList({
                    sortedList: filterDnmList(dnmList, searchState.value),
                    officeId,
                    dnmList,
                })}
            </div>
        </div>
    ))
);

function filterDnmList(list, search) {
    if(search === "") return list?.value;
    //Remove all multiple spaces
    search = search.replace(/ +(?= )/g,'');

    //Remove all commas
    search = search.replace(",", "");
    search = search.replace("#", "");
    search = search.replace(".", "");

    //Make array of all characters with " " delimiter 
    let searchFields = search.split(" ");

    //Remove empty items
    searchFields = searchFields.filter(n => n);

    let newList = list?.value.filter(item => {
        var match = true;
        searchFields.forEach(x => 
            item.address.toLowerCase().includes(x.toLowerCase()) ||
            item.city.toLowerCase().includes(x.toLowerCase()) ||
            item.state.toLowerCase().includes(x.toLowerCase()) ||
            item.zip.toLowerCase().includes(x.toLowerCase()) ? null : match = false)
        return (match ? item : null);
    });

    return newList;
}
